import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, ButtonBase, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { topicsFiltersButtonStyles, topicsHeaderStyles, topicsIconStyles, topicsListStyles, topicsPillStyles, topicsWrapperStyles } from './BlogListPage.styles';
import BlogTagFilterDrawer from './BlogTagFilterDrawer';
import { getHrefPath } from '../TAGLink/TAGLink.helpers';
import TAGSvgIcon from '../TAGSvgIcon';
interface IBlogTagFilterListProps {
  blogTagPath: string;
  migrationPaths?: string[];
  allTags: string[];
}
const toSentenceCase = (value: string) => {
  if (!value) {
    return value;
  }
  return `${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
};

// The active tag segments live in the URL (e.g. /tag/cats/dogs/2), so they're read from
// location rather than passed as props, matching the pattern used for tag pagination in BlogList.
const getActiveTagSegments = (pathname: string, blogTagPath: string): string[] => {
  const tagPathIndex = pathname.indexOf(blogTagPath);
  if (tagPathIndex === -1) {
    return [];
  }
  const segments = pathname.slice(tagPathIndex + blogTagPath.length).split('/').filter(Boolean);
  const lastSegment = segments.at(-1);
  if (segments.length > 1 && lastSegment !== undefined && /^\d+$/.test(lastSegment)) {
    return segments.slice(0, -1);
  }
  return segments;
};
export default function BlogTagFilterList({
  blogTagPath,
  migrationPaths,
  allTags
}: Readonly<IBlogTagFilterListProps>) {
  const [activeTagSegments, setActiveTagSegments] = useState<string[]>([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  useEffect(() => {
    setActiveTagSegments(getActiveTagSegments(globalThis.window.location.pathname, blogTagPath));
  }, [blogTagPath]);
  const getNextPath = (tagSegment: string) => {
    const remainingSegments = activeTagSegments.filter(segment => segment !== tagSegment);
    return remainingSegments.length ? `${blogTagPath}${remainingSegments.join('/')}` : blogTagPath;
  };
  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };
  return <>
			<Box data-testid="blog_tag_filter_list" sx={topicsWrapperStyles} data-sentry-element="Box" data-sentry-source-file="BlogTagFilterList.tsx">
				<Box sx={topicsHeaderStyles} data-sentry-element="Box" data-sentry-source-file="BlogTagFilterList.tsx">
					<ButtonBase onClick={handleOpenDrawer} sx={topicsFiltersButtonStyles} data-testid="blog_tag_filter_open_button" data-sentry-element="ButtonBase" data-sentry-source-file="BlogTagFilterList.tsx">
						<Box sx={topicsIconStyles} data-sentry-element="Box" data-sentry-source-file="BlogTagFilterList.tsx">
							<TAGSvgIcon icon="Tune" size={20} data-sentry-element="TAGSvgIcon" data-sentry-source-file="BlogTagFilterList.tsx" />
						</Box>
						<Typography variant="bodyMediumSemiBold" color="text.primary" component="h2" data-sentry-element="Typography" data-sentry-source-file="BlogTagFilterList.tsx">
							Topics
						</Typography>
					</ButtonBase>
				</Box>
				{!!activeTagSegments.length && <Box sx={topicsListStyles}>
						{activeTagSegments.map(tagSegment => {
          const label = toSentenceCase(decodeURIComponent(tagSegment).replaceAll('-', ' '));
          return <Button key={tagSegment} variant="secondaryDefault" size="XS" component="a" href={getHrefPath(getNextPath(tagSegment), migrationPaths)} endIcon={<CloseIcon />} sx={topicsPillStyles} data-testid={`blog_tag_filter_chip_${tagSegment}`}>
									{label}
								</Button>;
        })}
					</Box>}
			</Box>
			<BlogTagFilterDrawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} blogTagPath={blogTagPath} allTags={allTags} activeTagSegments={activeTagSegments} migrationPaths={migrationPaths} data-sentry-element="BlogTagFilterDrawer" data-sentry-source-file="BlogTagFilterList.tsx" />
		</>;
}